import {MessageSeverity} from './message-box-reducer';

export type ShowMessageAction = {
    type: 'SHOW_MESSAGE';
    id: string;
    heading?: string;
    text: string;
    severity?: MessageSeverity;
    timeout?: number;
};

type ClearMessageAction = {
    readonly type: 'CLEAR_MESSAGE';
    readonly id: string;
};

export type MessageBoxAction = ShowMessageAction | ClearMessageAction;

/**
 * Returns an action object for the targeted MessageBox component to display a given message.
 *
 * @param id the id of the MessageBox component which should display the message
 * @param text the message which should be displayed
 * @param severity (optional) which kind of message is displayed (info, warning, etc.)
 * @param heading (optional) header text
 * @param timeout (optional) how many milliseconds the message should be displayed before it clears itself automatically
 */
function showMessage(
    id: string,
    text: string,
    severity?: MessageSeverity,
    heading?: string,
    timeout?: number,
): ShowMessageAction {
    return { type: 'SHOW_MESSAGE', id, heading, text, severity, timeout: timeout ?? 5000 };
}

export function showError(id: string, message: string, heading?: string, timeout?: number): ShowMessageAction {
    return showMessage(id, message, MessageSeverity.DANGER, heading, timeout);
}

// noinspection JSUnusedGlobalSymbols
export function showSuccess(id: string, message: string, heading?: string, timeout?: number): ShowMessageAction {
    return showMessage(id, message, MessageSeverity.SUCCESS, heading, timeout);
}

export function showInfo(id: string, message: string, heading?: string, timeout?: number): ShowMessageAction {
    return showMessage(id, message, MessageSeverity.INFO, heading, timeout);
}

export function clearMessage(id: string): ClearMessageAction {
    return { type: 'CLEAR_MESSAGE', id };
}
